import axios from "axios";
import { createApi } from "@reduxjs/toolkit/query/react";
import getTenantId from "../../components/Tenent";
import {
  showAccessDeniedModal,
  showSessionExpiredModal,
} from "../slices/authSlice";

const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_DBSYNC_API,
  withCredentials: false,
  headers: { accept: "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["x-tenant-id"] = getTenantId();
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      getStore().dispatch(showSessionExpiredModal(window.location.pathname));
    }
    return Promise.reject(err);
  },
);

const axiosBaseQuery =
  () =>
  async ({ url, method, body, params, ...requestOpts }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;
      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      return { error: { status, data: errorData || axiosError.message } };
    }
  };

export const uploadHandlerApi = createApi({
  reducerPath: "uploadHandlerApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["upload-document"],
  endpoints: (builder) => ({
    processUploadDocument: builder.mutation({
      query: (body) => ({
        url: `/process-upload-document/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["upload-document"],
    }),
  }),
});

export const { useProcessUploadDocumentMutation } = uploadHandlerApi;
